module.exports = __webpack_public_path__ + "img/gift4-01-c02-t1.0584ebc8.png";